(function ($) {
  Drupal.behaviors.np_hero = {
    attach: function (context, settings) {
      $('#np_mod1', context).once('np_hero', function () {
        $(window).on('load', function () {
          if ($.cookie('boutique__video-cookie') == null) {
            $('.np_mod1_video video')[0].play();
            $.cookie('boutique__video-cookie', true);
            // hide intro video after first load
            $('.np_mod1_video video').on('ended', function () {
              $('.np_mod1_video').fadeOut('slow');
            });
          } else {
            $('.np_mod1_video').addClass('np_mod1_video_hide');
          }
        });

        /* QUICK SHOP FOR HERO */
        // Add ID to the mpp we are targeting
        var mppContextOne = $('.mpp:eq(0)');

        mppContextOne.attr('id', 'np_mod1_mpp');
        var targetQSExpandLoc = $('#np_mod1_QS').parent().parent();
        var targetQSOpenOne = $('#np_mod1_mpp').find(
          'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
        );

        targetQSOpenOne.addClass('targetQSOpen shop_now_dark');
        var targetQSCloseOne = $('#np_mod1_mpp').find(
          'a.product-brief__button-quickshop--close.js-quickshop-hide'
        );

        targetQSCloseOne.addClass('targetQSClose shop_now_dark');

        // Need to wait a moment for the li to be found.
        setTimeout(function () {
          var targetQSExpand = mppContextOne.find('.js-quickshop-container');

          targetQSExpand.addClass('np_mod1_qs_expanded');
          targetQSExpand.detach().insertAfter(targetQSExpandLoc);
          targetQSOpenOne.detach().insertBefore('#np_mod1_QS');
          targetQSCloseOne.detach().insertBefore('#np_mod1_QS');
          $('#np_mod1_mpp').remove();
        }, 200);

        /* Stars */
        // Animating the Stars.
        var starInit1 = new TimelineMax({
          repeat: -1
        });
        var star1 = $('#np_hero_star_1');

        starInit1.set(star1, {
          opacity: '1'
        });
        starInit1.to(star1, 3, {
          opacity: 0.1
        });
        starInit1.to(star1, 2, {
          opacity: 0.8
        });

        var starInit2 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var star2 = $('#np_hero_star_2');

        starInit2.set(star2, {
          opacity: '0.1'
        });
        starInit2.to(star2, 3, {
          opacity: 1
        });
        starInit2.to(star2, 4, {
          opacity: 0.1
        });

        var starInit3 = new TimelineMax({
          repeat: -1
        });
        var star3 = $('#np_hero_star_3');

        starInit3.set(star3, {
          opacity: '.4'
        });
        starInit3.to(star3, 2, {
          opacity: 0.2
        });
        starInit3.to(star3, 1, {
          opacity: 1
        });
        starInit3.to(star3, 0.5, {
          opacity: 0.9
        });
        starInit3.to(star3, 0.5, {
          opacity: 0.1
        });

        var starInit4 = new TimelineMax({
          repeat: -1
        });
        var star4 = $('#np_hero_star_4');

        starInit4.set(star4, {
          opacity: '1'
        });
        starInit4.to(star4, 3, {
          opacity: 0.2
        });

        var starInit5 = new TimelineMax({
          repeat: -1
        });
        var star5 = $('#np_hero_star_5');

        starInit5.set(star5, {
          opacity: '.5'
        });
        starInit5.to(star5, 3, {
          opacity: 1
        });
        starInit5.to(star5, 2, {
          opacity: 0.1
        });

        var starInit6 = new TimelineMax({
          repeat: -1
        });
        var star6 = $('#np_hero_star_6');

        starInit6.set(star6, {
          opacity: '.6'
        });
        starInit6.to(star6, 2, {
          opacity: 0.2
        });
        starInit6.to(star6, 2, {
          opacity: 0.9
        });

        var starInit7 = new TimelineMax({
          repeat: -1
        });
        var star7 = $('#np_hero_star_7');

        starInit7.set(star7, {
          opacity: '.6'
        });
        starInit7.to(star7, 2, {
          opacity: 0.2
        });
        starInit7.to(star7, 2, {
          opacity: 0.9
        });

        var starInit8 = new TimelineMax({
          repeat: -1
        });
        var star8 = $('#np_hero_star_8');

        starInit8.set(star8, {
          opacity: '.75'
        });
        starInit8.to(star8, 2, {
          opacity: 1
        });
        starInit8.to(star8, 3, {
          opacity: 0.6
        });
        starInit8.to(star8, 2, {
          opacity: 1
        });
        starInit8.to(star8, 1, {
          opacity: 0.1
        });

        var starInit9 = new TimelineMax({
          repeat: -1
        });
        var star9 = $('#np_hero_star_9');

        starInit9.set(star9, {
          opacity: '.3'
        });
        starInit9.to(star9, 2, {
          opacity: 0.8
        });
        starInit9.to(star9, 1, {
          opacity: 0.2
        });

        var starInit10 = new TimelineMax({
          repeat: -1
        });
        var star10 = $('#np_hero_star_10');

        starInit10.set(star10, {
          opacity: '.5'
        });
        starInit10.to(star10, 3, {
          opacity: 1
        });
        starInit10.to(star10, 2, {
          opacity: 0.2
        });

        var starInit11 = new TimelineMax({
          repeat: -1
        });
        var star11 = $('#np_hero_star_11');

        starInit11.set(star11, {
          opacity: '1'
        });
        starInit11.to(star11, 3, {
          opacity: 0.1
        });
        starInit11.to(star11, 2, {
          opacity: 0.9
        });

        var starInit12 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var star12 = $('#np_hero_star_12');

        starInit12.set(star12, {
          opacity: '0.1'
        });
        starInit12.to(star12, 4, {
          opacity: 1
        });
        starInit12.to(star12, 2, {
          opacity: 0.1
        });

        var starInit13 = new TimelineMax({
          repeat: -1
        });
        var star13 = $('#np_hero_star_13');

        starInit13.set(star13, {
          opacity: '.4'
        });
        starInit13.to(star13, 1, {
          opacity: 0.2
        });
        starInit13.to(star13, 2, {
          opacity: 1
        });
        starInit13.to(star13, 0.5, {
          opacity: 0.9
        });
        starInit13.to(star13, 1.5, {
          opacity: 0.1
        });

        var starInit14 = new TimelineMax({
          repeat: -1
        });
        var star14 = $('#np_hero_star_14');

        starInit14.set(star14, {
          opacity: '1'
        });
        starInit14.to(star14, 5, {
          opacity: 0.2
        });
        starInit14.to(star14, 4, {
          opacity: 0.8
        });

        var starInit15 = new TimelineMax({
          repeat: -1
        });
        var star15 = $('#np_hero_star_15');

        starInit15.set(star15, {
          opacity: '.5'
        });
        starInit15.to(star15, 1, {
          opacity: 1
        });
        starInit15.to(star15, 4, {
          opacity: 0.1
        });

        var starInit16 = new TimelineMax({
          repeat: -1
        });
        var star16 = $('#np_hero_star_16');

        starInit16.set(star16, {
          opacity: '.6'
        });
        starInit16.to(star16, 2, {
          opacity: 0.2
        });
        starInit16.to(star16, 3, {
          opacity: 0.9
        });

        var starInit17 = new TimelineMax({
          repeat: -1
        });
        var star17 = $('#np_hero_star_17');

        starInit17.set(star17, {
          opacity: '.6'
        });
        starInit17.to(star17, 1, {
          opacity: 0.2
        });
        starInit17.to(star17, 2, {
          opacity: 0.9
        });

        var starInit18 = new TimelineMax({
          repeat: -1
        });
        var star18 = $('#np_hero_star_18');

        starInit18.set(star18, {
          opacity: '.75'
        });
        starInit18.to(star18, 2, {
          opacity: 1
        });
        starInit18.to(star18, 1, {
          opacity: 0.6
        });
        starInit18.to(star18, 2, {
          opacity: 1
        });
        starInit18.to(star18, 3, {
          opacity: 0.1
        });

        var starInit19 = new TimelineMax({
          repeat: -1
        });
        var star19 = $('#np_hero_star_19');

        starInit19.set(star19, {
          opacity: '1'
        });
        starInit19.to(star19, 4, {
          opacity: 0.2
        });
        starInit19.to(star19, 2, {
          opacity: 1
        });

        var starInit20 = new TimelineMax({
          repeat: -1
        });
        var star20 = $('#np_hero_star_20');

        starInit20.set(star20, {
          opacity: '.2'
        });
        starInit20.to(star20, 2, {
          opacity: 1
        });
        starInit20.to(star20, 3, {
          opacity: 0.2
        });

        var starInit21 = new TimelineMax({
          repeat: -1
        });
        var star21 = $('#np_hero_star_21');

        starInit21.set(star21, {
          opacity: '1'
        });
        starInit21.to(star21, 1, {
          opacity: 0.1
        });
        starInit21.to(star21, 2, {
          opacity: 0.9
        });
      });
    }
  };
})(jQuery);
